<template>
    <AddBonLivraison />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddBonLivraison from "@/components/GesCom/BonLivraison/AddBonLivraison.vue";
  
    export default defineComponent({
      name: "AddBonLivraisonPage",
      components: {
        
        AddBonLivraison,
      },
    });
  </script>